import { Forbidden } from '@/components/common/Forbidden';

const NoPermissionPage = () => {
  return <Forbidden />;
};

export default NoPermissionPage;
